<template>
  <div id="asdasdas"></div>
</template>

<script>
import DistanceController from "../DistanceController"
import a from "./a"

export default {
  name: "distanceDemo",
  data() {
    return {
      content: [
        "勾朝辉",
        "实：2023-06-13",
        "应：2023-06-13",
      ]
    }
  },
  mounted() {
    let obj = DistanceController.GetInstance("asdasdas", a)
    console.log(obj)
    obj.show()

    // setTimeout(() => {
    //   console.log("掉了删除")
    //   obj.close()
    // }, 3000)

  },
  methods: {}
}
</script>

<style scoped>

</style>
